<template>
  <div class="container">
    <span class="close-btn" @click="closeKeyboard">X</span>
    <div class="simple-keyboard hg-theme-default"></div>
  </div>
</template>

<script>
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";

export default {
  name: "Keyboard",
  props: {
    value: { type: String, default: "" },
    mask: { type: Function, default: null },
  },
  data() {
    return {
      keyboard: null,
      layoutName: "shift",
      currentValue: "",
    };
  },
  mounted() {
    if (this.value) {
      this.currentValue = this.value.replace(/[^a-zA-Z0-9]/g, "");
    }

    this.keyboard = new Keyboard(".simple-keyboard", {
      onKeyPress: (button) => this.onKeyPress(button),
      display: {
        "{bksp}": "⇦",
        "{enter}": "Enter",
        "{shift}": "Shift",
        "{lock}": "Caps",
        "{space}": "Espaço",
        "{close}": "⇩",
      },
      layout: {
        default: [
          "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
          "{tab} q w e r t y u i o p [ ] \\",
          "{lock} a s d f g h j k l ; ' {enter}",
          "{shift} z x c v b n m , . / {close}",
          ".com @ {space}",
        ],
        shift: [
          "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
          "{tab} Q W E R T Y U I O P { } |",
          '{lock} A S D F G H J K L : " {enter}',
          "{shift} Z X C V B N M < > ? {close}",
          ".com @ {space}",
        ],
      },
      buttonTheme: [
        {
          class: "highlight-btn",
          buttons: "{close} ",
        },
      ],
      autoUseTouchEvents: true,
      layoutName: "shift",
    });

    this.keyboard.setInput(this.value);
  },
  watch: {
    layoutName(newValue) {
      if (this.keyboard) {
        this.keyboard.setOptions({ layoutName: newValue });
      }
    },
    value(newValue) {
      let cleanNewValue;

      if (this.mask) {
        cleanNewValue = newValue.replace(/[^a-zA-Z0-9]/g, "") || "";
      } else {
        cleanNewValue = newValue;
      }

      if (this.currentValue !== cleanNewValue) {
        this.currentValue = cleanNewValue;
        if (this.keyboard && this.keyboard.getInput() !== newValue) {
          this.keyboard.setInput(newValue);
        }
      }
    },
  },
  methods: {
    onKeyPress(button) {
      const actions = {
        "{enter}": () => {
          this.$emit("enter", this.currentValue);
          this.closeKeyboard();
        },
        "{close}": () => this.$emit("close"),
        "{shift}": () =>
          (this.layoutName =
            this.layoutName === "default" ? "shift" : "default"),
        "{lock}": () =>
          (this.layoutName =
            this.layoutName === "default" ? "shift" : "default"),
        "{bksp}": () => (this.currentValue = this.currentValue.slice(0, -1)),
        "{space}": () => (this.currentValue += " "),
      };

      if (actions[button]) {
        actions[button]();
      } else if (button.length === 1) {
        this.currentValue += button;
      }

      const formatted = this.mask
        ? this.mask(this.currentValue)
        : this.currentValue;

      this.keyboard.setInput(formatted);
      this.$emit("input", formatted);
    },
    closeKeyboard() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.simple-keyboard {
  position: fixed;
  bottom: 0;
  left: 20px;
  right: 0;
  min-width: 100vw !important;
  z-index: 1000;
}

:deep(.highlight-btn) {
  background: linear-gradient(to right, #e15550, #ef7f55) !important;
}

:deep(.highlight-btn span) {
  color: white !important;
}

.container {
  position: relative;
  display: inline-block;
}

.close-btn {
  position: fixed;
  bottom: 270px;
  left: 10px;
  cursor: pointer;
  background-color: white;
  border: 2px solid #ebeef6;
  color: #6e6e81;
  /* font-weight: bold; */
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  z-index: 1101;
  transition: transform 0.2s ease;
}

.close-btn:hover {
  transform: scale(1.1);
}
</style>
